import { type TCollectionSimple } from '@core/models'
import { convertCollection } from '@core/converters'
import { useCollectionSimple } from '@features/collection'

import { useCollectionScreenLoaderData } from './useCollectionScreenLoaderData'

export const useCollectionScreenCollection = (): TCollectionSimple => {
    const { collection } = useCollectionScreenLoaderData()
    const { data } = useCollectionSimple({ username: collection.username, slug: collection.slug })

    return data ?? convertCollection(collection)
}
